import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";

import { WetstockListComponent } from "./wetstock-list/wetstock-list.component";

import { UnsavedChangesGuard } from "src/app/shared/guard/pending.guard";

const wetstockRoutes: Routes = [
  { path: "", component: WetstockListComponent },
  { path: "reset", redirectTo: "wetstock", pathMatch: "prefix" },
];

@NgModule({
  imports: [RouterModule.forChild(wetstockRoutes)],
  exports: [RouterModule],
})
export class WetstockRoutingModule {}
